module.exports = __webpack_public_path__ + "img/product-touch-screen-tv.3fa462a2.jpg";